import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { Qualification } from '@ps/survey-utils';

import { QualificationDto } from './dtos/qualification.dto';
import { QualificationMapper } from './mappers/qualification.mapper';

@Injectable({ providedIn: 'root' })
export class QualificationsApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = this._env.pureSpectrum.url;
  private readonly _mapper = new QualificationMapper();

  public getQualifications(
    countryCode: string,
    languageCode: string,
  ): Observable<Qualification[]> {
    return this._http
      .get<
        QualificationDto[]
      >(`${this._baseUrl}/buyers/v3/attributes/ui/${countryCode}/${languageCode}`)
      .pipe(map((response) => this._mapper.fromDtoList(response)));
  }
}
